import { DatePipe } from '@angular/common';
import { Directive, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { contentDateToMilliseconds, millisecondsToSeconds } from '../../utils';

@Directive()
export abstract class CardFooterBaseComponent {
  @Input() className?: string;

  constructor(
    protected translate: TranslateService,
    protected datePipe: DatePipe
  ) {}

  /**
   * Renders a content date as a relative label, falling back to a formatted date for anything older
   * than a week.
   *
   * Accepts both the ISO strings of the content V2 endpoints and the epoch seconds the V1 public
   * content endpoints still return, and returns an empty string when there is no usable date.
   */
  protected setTimeAgo(publishedAt: string | number | null | undefined): string {
    const milliseconds = contentDateToMilliseconds(publishedAt);
    if (milliseconds === null) {
      return '';
    }

    const timeDifference = millisecondsToSeconds(Date.now() - milliseconds);
    if (timeDifference < 59) {
      return this.translate.instant('announcements.time_ago_now');
    } else if (timeDifference < 3600) {
      const minutes = Math.floor(timeDifference / 60);
      return (
        this.translate.instant('announcements.time_ago_prefix') +
        ' ' +
        minutes +
        ' ' +
        this.translate.instant('announcements.time_ago_minutes')
      );
    } else if (timeDifference < 86400) {
      const hours = Math.floor(timeDifference / 3600);
      return (
        this.translate.instant('announcements.time_ago_prefix') +
        ' ' +
        hours +
        ' ' +
        this.translate.instant('announcements.time_ago_hours')
      );
    } else if (timeDifference < 604800) {
      const days = Math.floor(timeDifference / 86400);
      return (
        this.translate.instant('announcements.time_ago_prefix') +
        ' ' +
        days +
        ' ' +
        this.translate.instant('announcements.time_ago_days')
      );
    } else {
      return this.datePipe.transform(milliseconds, 'EEEEEE dd.MM.yyyy') || '';
    }
  }
}
